import React, { ReactNode } from 'react';
import { connectStateResults, StateResultsProvided } from 'react-instantsearch-core';
import {
    StyledConditionallyHidden,
    StyledNoResults,
    StyledSearchQuery,
    StyledOverlineText,
    StyledCategoriesWrapper,
    StyledNotFoundText,
} from './styled';
import { Text, RouterLink, Button } from '$shared/components';
import { useRouter } from 'next/router';
import { Link as LinkType, Modules } from '~/lib/data-contract';
import { useTranslation } from '~/shared/utils';
import { DynamicBlockList } from '~/templates/blocks';

type StateResultsProps = StateResultsProvided & {
    children?: ReactNode;
    categories?: LinkType[];
    content?: Modules[];
    type?: 'plp' | 'carousel' | 'search';
};

const CustomNoResults = ({
    searchResults,
    children,
    categories,
    content,
    searching,
    type = 'plp',
}: StateResultsProps) => {
    const router = useRouter();
    const { translate } = useTranslation();
    const searchedTerm = router.query.query;
    const isNoResults = searchResults?.nbHits == 0 && !searching;

    return (
        <>
            <StyledConditionallyHidden isHidden={isNoResults}>{children}</StyledConditionallyHidden>
            {isNoResults && type === 'search' ? (
                <>
                    <StyledNoResults>
                        <StyledNotFoundText variant="display2">
                            {translate('search.noResultsFor')}{' '}
                            <StyledSearchQuery>"{searchedTerm}"</StyledSearchQuery>
                        </StyledNotFoundText>
                        <Text variant="body">{translate('search.noResultsText')}</Text>
                        {categories?.length ? (
                            <>
                                <StyledOverlineText variant="overline">
                                    {translate('search.browseCategories')}
                                </StyledOverlineText>

                                <StyledCategoriesWrapper>
                                    {categories?.map(({ url, title, target, text }) => (
                                        <RouterLink href={url || ''} prefetch={false} key={url}>
                                            <Button
                                                as="a"
                                                rounded
                                                size="sm"
                                                shape="icon"
                                                target={target}
                                                title={title}
                                                variant="secondary"
                                            >
                                                {' '}
                                                {text || title}
                                            </Button>
                                        </RouterLink>
                                    ))}
                                </StyledCategoriesWrapper>
                            </>
                        ) : null}
                    </StyledNoResults>
                    {content?.length ? <DynamicBlockList elements={content} /> : null}
                </>
            ) : null}
        </>
    );
};

export const NoResults = connectStateResults<StateResultsProps>(CustomNoResults);
